import * as React from "react";
import type { SVGProps } from "react";
const SvgNumOne = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={25}
    fill="none"
    {...props}
  >
    <circle cx={13} cy={12.5} r={12.5} fill="#18A09F" />
    <path fill="#fff" d="M10.68 5v1.28h3.3V19h1.44V5z" />
  </svg>
);
export default SvgNumOne;
